export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 136.9">
    <path fill="#D0E0E1" d="M0 12.5C0 5.6 5.6 0 12.5 0h54.1L100 34v90.5c0 6.9-6.2 12.4-13.1 12.4H12.5c-6.9 0-12.5-5.6-12.5-12.5V12.5z"/>
    <g fill="#6D7577">
        <path d="M39.2 91.4H25.1v-2.8H43v2.8l-15.2 19h15.6v2.8H23.9v-2.8l15.3-19zM50.2 88.6v24.5H47V88.6h3.2zM66.5 88.6c2.5 0 4.3.6 5.6 1.9 1.3 1.3 1.9 3.1 1.9 5.3 0 2.3-.6 4.1-1.9 5.4-1.3 1.3-3.1 1.9-5.6 1.9H59v10h-3.3V88.6h10.8zm-1.1 11.8c1.9 0 3.2-.4 4.1-1.1s1.3-1.9 1.3-3.4-.4-2.6-1.3-3.4c-.9-.8-2.2-1.2-4.1-1.2H59v9h6.4z"/>
    </g>
    <path fill="${fill? fill : '#A1AFAF'}" d="M66.6 0v34H100L66.6 0z"/>
</svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/files/zip.jsx